<template>
  <div class="overviewappusers-container">
    <div class="search-layout">
      <div class='date-picker'>
        <el-date-picker
            v-model="searchTime"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :range-separator="$t('public.name9')"
            :start-placeholder="$t('public.name10')"
            :end-placeholder="$t('public.name11')"
          >
          </el-date-picker>
        <el-button type="primary" size="small" @click="queryList" class="search-bt">{{ $t('public.name3') }}</el-button>
      </div>
    </div>
    <el-table :data="tableList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading="tableLoading">
      <el-table-column :label="$t('operate.name191')" prop="pushId" sortable></el-table-column>
      <el-table-column :label="$t('operate.name192')" prop="senderId" sortable> </el-table-column>
      <el-table-column :label="$t('operate.name193')" prop="msgType" sortable>
        <template>
           <div>{{ $t('operate.name198') }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('operate.name194')" prop="bizCode" sortable></el-table-column>
      <el-table-column :label="$t('operate.name195')" prop="msgId" sortable></el-table-column>
      <el-table-column :label="$t('operate.name196')" prop="msgTime" sortable>
        <template slot-scope="scope">
          {{ scope.row.msgTime | tzDisplay }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('operate.name197')" prop="content" sortable></el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="queryInfo.limit"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>

    <AppDialog width="488px" :title="$t('operate.name50')" :visible.sync="dialogVisible" v-if="dialogVisible" :before-close="handleClose">
      <el-form ref="passwordFormRef" :model="passwordInfo" :rules="passwordFormRules" size="medium" :label-width="formLabelWidth()">
        <el-col :span="24">
          <el-form-item :label="$t('operate.name164')" prop="newpwd">
            <el-input v-model="passwordInfo.newpwd" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('operate.name165')" prop="confimPassword">
            <el-input v-model="passwordInfo.confimPassword" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
        </el-col>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t('public.name14') }}</el-button>
        <el-button type="primary" @click="chanePassWord">{{ $t('public.name25') }}</el-button>
      </span>
    </AppDialog>

    <AppDialog size="lg" width="50%" :title="$t('operate.name49')" :visible.sync="associatedVehiclesDialog" v-if="associatedVehiclesDialog" :before-close="handleClose">
      <el-table :data="eBikeInfoList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading="tableLoading1">
      <el-table-column :label="$t('bike.name294')" prop="loginName" sortable></el-table-column>
      <el-table-column :label="$t('operate.name160')" prop="nickName" sortable> </el-table-column>
      <el-table-column :label="$t('bike.name34')" prop="tenantType" sortable></el-table-column>
      <el-table-column :label="$t('operate.name22')">
        <template slot-scope="scope">
          <el-button type="text" @click="bindingRoles(scope.row)">{{ $t('operate.name161') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    </AppDialog>
  </div>
</template>
<script>
import { pushMsgList, appUserUpdateStatus, updateAppPwd } from '@/api/operate.js'
import { tenantList } from '@/api/manage.js'
import { mapGetters } from 'vuex'
import AppDialog from '@/components/AppDialog/index.vue'
export default {
  components: { AppDialog },
  computed: {
    ...mapGetters(['userinfo'])
  },
  data() {
    return {
      cascaderOptions: [],
      statusList: ['新提出', '已查阅', '处理中', '已拒绝', '已关闭'],
      associatedVehiclesDialog: false,
      eBikeInfoList: [],
      tableLoading1: false,
      tableLoading: false,
      dialogVisible: false,
      passwordInfo: {
        userId: '',
        newpwd: '',
        confimPassword: ''
      },
      searchTime: null,
      queryInfo: {
        startTime: '',
        page: 1,
        limit: 10,
        endTime: ''
      },
      tableList: [],
      statusOption: [
        {
          value: 2,
          label: '全部'
        },
        {
          value: 0,
          label: '新提出'
        },
        {
          value: 1,
          label: '已查阅'
        },
        {
          value: 1,
          label: '处理中'
        },
        {
          value: 1,
          label: '已拒绝'
        },
        {
          value: 1,
          label: '已关闭'
        }
      ],
      total: 0,
      selectList: [],
      userInfoRules: {
        account: [
          {
            required: true,
            message: this.$t('screen.name8'),
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true,
            message: this.$t('login.name3'),
            trigger: 'blur'
          }
        ]
      },
      userInfo: {
        account: '',
        password: '',
        name: '',
        nikeName: '',
        tel: '',
        email: '',
        status: '1'
      },
      showMsgVisible: false,
      rolesInfo: {
        roles: ''
      },
      showMsgallVisible: false,
      rolesOptions: [
        { label: '管理员', value: '1' },
        { label: '业务员', value: '2' }
      ]
    }
  },
  created() {
    console.log('userinfo===', this.userinfo)
  },
  mounted() {
    this.queryList()
  },
  methods: {
    bindingRoles(row) {
      this.bindingRolesDialog = true
    },

    associatedVehicles() {
      this.associatedVehiclesDialog = true
    },

    resetQuery() {
      this.queryInfo = {
        page: 1,
        limit: 10
      }
      this.searchTime = null
      this.queryList()
    },

    queryList() {
      this.tableLoading = true
      const data = {
        page: this.queryInfo.page,
        limit: this.queryInfo.limit
      }
      if (this.searchTime) {
        const { startTime, endTime } = this.$tz.rangeToAccountQuery(this.searchTime)
        data.startTime = startTime
        data.endTime = endTime
      }
      pushMsgList(data)
        .then(res => {
          this.tableList = res.data.list
          this.total = res.data.total
          this.tableLoading = false
        })
        .catch(() => {
          this.tableList = []
          this.total = 0
          this.tableLoading = false
        })
    },

    changeSwitch(row, e) {
      this.tableLoading = true
      appUserUpdateStatus({ id: row.userId })
        .then(res => {
          this.tableLoading = false
        })
        .catch(() => {
          this.tableLoading = false
        })
    },

    resetPassword(row) {
      this.passwordInfo.userId = row.userId
      this.dialogVisible = true
    },
    handleClose() {
      this.passwordInfo = {
        userId: '',
        newpwd: '',
        confimPassword: ''
      }
      this.dialogVisible = false
      this.associatedVehiclesDialog = false
    },
    loadOptions(node, resolve) {
      // console.log('===', node)
      if (node.level === 2) {
        resolve([])
        return
      }
      let data = {
        page: 1,
        limit: 500,
        tenantType: 1
      }

      if (node.level === 1) {
        data = {
          page: 1,
          limit: 500,
          tenantType: 2,
          parentId: node.value
        }
      }
      tenantList(data)
        .then(res => {
          if (res.data.list) {
            const options = res.data.list.map(item => ({
              value: item.tenantId,
              label: item.tenantName,
              leaf: node.level >= 1
            }))
            resolve(options)
          } else {
            resolve([])
          }
        })
        .catch(() => {})
    },
    handleChange(value) {
      // 处理选项变化
      this.queryInfo.tenantId = value[value.length - 1]
      this.queryList()
    },

    chanePassWord() {
      this.$refs.passwordFormRef.validate(valid => {
        if (valid) {
          updateAppPwd(this.passwordInfo)
            .then((res) => {
              if (res.code === 200) {
                this.handleClose()
                this.$message({
                  type: 'success',
                  message: this.$t('screen.name10')
                })
              }
            })
            .catch(() => {})
        } else {
          return false
        }
      })
    },
    handleSizeChange(newSize) {
      this.queryInfo.limit = newSize
      this.queryList()
    },
    // 监听页码值改变事件
    handleCurrentChange(newPage) {
      this.queryInfo.page = newPage
      this.queryList()
    }
  }
}
</script>
<style lang="scss" scoped>
.overviewappusers-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  .search-layout {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .bt-layout {
    display: flex;
    flex-direction: row;
    height: 36px;
  }
  .date-picker{
    display: flex;
    flex-direction: row;
   .search-bt{
      margin-left: 25px;
    }
  }

  .qiyong {
    width: 54px;
    height: 24px;
    text-align: center;
    border-radius: 2px;
    background: #ebf6ed;
    color: #39ab4c;

    .text:before {
      content: '';
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 2px;
      background: #39ab4c;
      margin-right: 5px;
    }
  }

  .jinyong {
    width: 54px;
    height: 24px;
    text-align: center;
    border-radius: 2px;
    background: #fcecec;
    color: #ea4646;

    .text:before {
      content: '';
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 2px;
      background: #ea4646;
      margin-right: 5px;
    }
  }
}
</style>
